const HOUSEHOLD_DESIGNATION_CODES = {
  ADULT_CO_TENANT: 'A',
  CHILD: 'C',
  FOSTER_CHILD_ADULT: 'F',
  HEAD_OF_HOUSEHOLD: 'H',
  LIVE_IN_CARETAKER: 'L',
  OTHER_FAMILY_MEMBER: 'O',
  SPOUSE: 'S',
  UNBORN_CHILD: 'U',
};

export default HOUSEHOLD_DESIGNATION_CODES;
